import { Checkbox } from "@king-ict/eupisi-ui/components";
import { nameof } from "@king-ict/eupisi-ui/utils";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { PAYLOAD_CREATORS } from "./constants";
import { Form7Field } from "./types";
import { ValidationFailure } from "../../../../../models";
import { Form7, Request, RequestType } from "../../../../../models/Request";

interface IProps {
  form7: Form7;
  item: Request;
  errors?: ValidationFailure[];
  isEditing: boolean;
  onChange: (updatedForm7: Form7) => void;
}

export function Form7TypeSection({
  form7,
  item,
  errors,
  isEditing,
  onChange,
}: IProps) {
  const { t } = useTranslation();

  const handleForm7Change = (field: Form7Field, value: boolean) => {
    const payloadCreator = PAYLOAD_CREATORS[field];

    if (!payloadCreator) return;

    const updatedForm7 = payloadCreator(form7, item, value);
    onChange(updatedForm7);
  };

  return (
    <div>
      <Row>
        <Col md={12}>
          <Checkbox
            label={t("form7.isEarlyEnrollmentApproved")}
            name={nameof<typeof form7>("isEarlyEnrollmentApproved")}
            checked={form7.isEarlyEnrollmentApproved}
            onChange={(e) =>
              handleForm7Change("isEarlyEnrollmentApproved", e.target.checked)
            }
            errorText={
              errors?.find((e) =>
                e.propertyName?.startsWith("IsEarlyEnrollmentApproved")
              )?.message
            }
            plaintext={!isEditing}
            disabled={item.type !== RequestType.EarlyEnrollment}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Checkbox
            label={t("form7.isEarlyEnrollmentRejected")}
            name={nameof<typeof form7>("isEarlyEnrollmentRejected")}
            checked={form7.isEarlyEnrollmentRejected}
            onChange={(e) =>
              handleForm7Change("isEarlyEnrollmentRejected", e.target.checked)
            }
            errorText={
              errors?.find((e) =>
                e.propertyName?.startsWith("IsEarlyEnrollmentRejected")
              )?.message
            }
            plaintext={!isEditing}
            disabled={item.type !== RequestType.EarlyEnrollment}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Checkbox
            label={t("form7.isEnrollmentPostponement")}
            name={nameof<typeof form7>("isEnrollmentPostponement")}
            checked={form7.isEnrollmentPostponement}
            onChange={(e) =>
              handleForm7Change("isEnrollmentPostponement", e.target.checked)
            }
            errorText={
              errors?.find((e) =>
                e.propertyName?.startsWith("IsEnrollmentPostponement")
              )?.message
            }
            plaintext={!isEditing}
            disabled={
              !(
                item.type === RequestType.RegularEnrollment ||
                item.type ===
                  RequestType.RegularEnrollmentForChildrenWithLearningDifficulties
              )
            }
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Checkbox
            label={t("form7.isTemporaryExemptionApproved")}
            name={nameof<typeof form7>("isTemporaryExemptionApproved")}
            checked={form7.isTemporaryExemptionApproved}
            onChange={(e) =>
              handleForm7Change(
                "isTemporaryExemptionApproved",
                e.target.checked
              )
            }
            errorText={
              errors?.find((e) =>
                e.propertyName?.startsWith("IsTemporaryExemptionApproved")
              )?.message
            }
            plaintext={!isEditing}
            disabled={item.type !== RequestType.TemporaryExemption}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Checkbox
            label={t("form7.isTemporaryExemptionRejected")}
            name={nameof<typeof form7>("isTemporaryExemptionRejected")}
            checked={form7.isTemporaryExemptionRejected}
            onChange={(e) =>
              handleForm7Change(
                "isTemporaryExemptionRejected",
                e.target.checked
              )
            }
            errorText={
              errors?.find((e) =>
                e.propertyName?.startsWith("IsTemporaryExemptionRejected")
              )?.message
            }
            plaintext={!isEditing}
            disabled={item.type !== RequestType.TemporaryExemption}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Checkbox
            label={t("form7.isAppropriateProgram")}
            name={nameof<typeof form7>("isAppropriateProgram")}
            checked={form7.isAppropriateProgram}
            onChange={(e) =>
              handleForm7Change("isAppropriateProgram", e.target.checked)
            }
            errorText={
              errors?.find((e) =>
                e.propertyName?.startsWith("IsAppropriateProgram")
              )?.message
            }
            plaintext={!isEditing}
            disabled={
              !(
                item.type === RequestType.RegularEnrollment ||
                item.type ===
                  RequestType.RegularEnrollmentForChildrenWithLearningDifficulties
              )
            }
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Checkbox
            label={t("decisionProposal.isPreparatoryCourse")}
            name={nameof<typeof form7>("isPreparatoryCourse")}
            checked={form7.isPreparatoryCourse}
            onChange={(e) =>
              handleForm7Change("isPreparatoryCourse", e.target.checked)
            }
            errorText={
              errors?.find((e) =>
                e.propertyName?.startsWith("IsPreparatoryCourse")
              )?.message
            }
            plaintext={!isEditing}
            disabled={
              form7.isEarlyEnrollmentRejected ||
              form7.isEnrollmentPostponement ||
              form7.isTemporaryExemptionApproved ||
              form7.isTemporaryExemptionRejected
            }
          />
        </Col>
      </Row>
    </div>
  );
}
